"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMember = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Calls API to update member's Steam data.
 *
 * Member is identified by their Steam ID.
 *
 * ## Usage
 *
 * ```ts
 * const memberId: string = "49i8675849302938457";
 * const { message } = await sdk.updateMember({ memberId });
 * ```
 *
 * @param params.memberId - ID of the member to update.
 */
const updateMember = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { memberId } = params;
    const url = `${BASE_URL}/members/member/${memberId}/update`;
    const updateResponse = yield axios_1.default.put(url, {}, { validateStatus: () => true });
    const { status, data } = updateResponse;
    if (status !== 202)
        throw new Error(data.error);
    return data;
});
exports.updateMember = updateMember;
